import * as React from 'react';
const HomeContext = React.createContext(null);
export default HomeContext;
